import { DriverPenaltiesService } from '@/backend/market'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DriverPenaltyEntity } from '../../domain/entities/DriverPenaltyEntity'
import type { DriverPenaltyFilterEntity } from '../../domain/entities/DriverPenaltyFilterEntity'
import type { PostDriverPenaltyEntity } from '../../domain/entities/PostDriverPenaltyEntity'
import { DriverPenaltyRepository } from '../../domain/repositories/DriverPenaltyRepository'
import { DriverPenaltyFilterModel } from '../models/DriverPenaltyFilterModel'
import { DriverPenaltyModel } from '../models/DriverPenaltyModel'
import { PostDriverPenaltyModel } from '../models/PostDriverPenaltyModel'

export class DriverPenaltyRepositoryImpl implements DriverPenaltyRepository {
  async getDriverPenalties(
    filterData: DriverPenaltyFilterEntity
  ): Promise<PaginateEntity<DriverPenaltyEntity[]> | { error: true }> {
    const driverPenaltyFilterModel = new DriverPenaltyFilterModel(filterData)

    try {
      const response = await DriverPenaltiesService.getDriverPenaltiesAdmin(driverPenaltyFilterModel)
      const driverPenaltyModels = response.items?.map((item) => new DriverPenaltyModel(item))
      return new PaginateEntity<DriverPenaltyEntity[]>(response, driverPenaltyModels)
    } catch {
      return { error: true }
    }
  }

  async createDriverPenalty(
    data: PostDriverPenaltyEntity
  ): Promise<DriverPenaltyEntity | { error: true }> {
    const requestModel = new PostDriverPenaltyModel(data)

    try {
      const response = await DriverPenaltiesService.postDriverPenaltyAdmin({
        requestBody: requestModel
      })
      return new DriverPenaltyModel(response)
    } catch {
      return { error: true }
    }
  }

  async approveDriverPenalty(id: string): Promise<DriverPenaltyEntity | { error: true }> {
    try {
      const response = await DriverPenaltiesService.patchApproveDriverPenaltyAdmin({ id })
      return new DriverPenaltyModel(response)
    } catch {
      return { error: true }
    }
  }

  async rejectDriverPenalty(id: string): Promise<DriverPenaltyEntity | { error: true }> {
    try {
      const response = await DriverPenaltiesService.patchRejectDriverPenaltyAdmin({ id })
      return new DriverPenaltyModel(response)
    } catch {
      return { error: true }
    }
  }
}
